export default __webpack_public_path__ + "static/media/Lupus, giurati ed autori.ce011c8e.jpg";